import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { DesignLibraryModal } from "../ui/common_components/DesignLibraryModal";
import { usePromptInputActions, AttachedDesign } from "../view_stores/usePromptInputStore";

interface DesignLibraryModalContextType {
  open: () => void;
  close: () => void;
}

const DesignLibraryModalContext = createContext<
  DesignLibraryModalContextType | undefined
>(undefined);

export function useDesignLibraryModal() {
  const ctx = useContext(DesignLibraryModalContext);
  if (!ctx)
    throw new Error(
      "useDesignLibraryModal must be used within a DesignLibraryModalProvider"
    );
  return ctx;
}

export function DesignLibraryModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { setAttachedDesign } = usePromptInputActions();

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleSelectDesign = useCallback(
    (design: AttachedDesign) => {
      setAttachedDesign(design);
    },
    [setAttachedDesign]
  );

  return (
    <DesignLibraryModalContext.Provider value={{ open, close }}>
      {children}
      {isOpen && (
        <DesignLibraryModal
          onClose={close}
          onSelectDesign={handleSelectDesign}
        />
      )}
    </DesignLibraryModalContext.Provider>
  );
}
